import Vue from 'vue'
import formValidation from '@/assets/plugins/formvalidation/dist/es6/core/Core'

Vue.use(formValidation)
